import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const LIST_USU_CONECT = `${API_URL}/administrador/estadisticas/usuarios_conectados`;
const GET_ACCESOS_WEB = `${API_URL}/administrador/estadisticas/accesos_web`;
const GET_ACCESOS_DIA_EN_CURSO = `${API_URL}/administrador/estadisticas/accesos_dia_hoy`;
const GET_ACCESOS_NOMINA_DIA_EN_CURSO = `${API_URL}/administrador/estadisticas/accesos_nomina_hoy`;
const GET_HISTORIAL_ACCESOS_USUARIO = `${API_URL}/administrador/estadisticas/accesos_usuario`;
const GET_HISTORIAL_NO_ACCESOS_USUARIO = `${API_URL}/administrador/estadisticas/no_accesos_usuario`;
const LIST_ACC_NOMINA = `${API_URL}/administrador/estadisticas/accesos_nomina`;
const LIST_USUARIO_FNMT = `${API_URL}/administrador/estadisticas/accesos_usuario_fnmt`;
const BUSQUEDA_USUARIO_ACCEDIDO = `${API_URL}/administrador/estadisticas/buscador`;

export async function getUsuariosConectados(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${LIST_USU_CONECT}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger usuarios conectados"));
}

export async function getAccesosNomina(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${LIST_ACC_NOMINA}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger accesos nómina"));
}

export async function getHistUsuCertDig(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${LIST_USUARIO_FNMT}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger accesos nómina"));
}

export async function getAccesosWeb(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${GET_ACCESOS_WEB}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger el Cuadre"));
}

export async function getAccesosDiaEnCurso(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${GET_ACCESOS_DIA_EN_CURSO}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger el Cuadre"));
}

export async function getAccesosNominaDiaEnCurso(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${GET_ACCESOS_NOMINA_DIA_EN_CURSO}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger el Cuadre"));
}

export async function getHistorialAccesos(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${GET_HISTORIAL_ACCESOS_USUARIO}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger el Cuadre"));
}

export async function getHistorialNoAccesos(numPagina, tamano) {
  return await axios({
    method: "GET",
    url: `${GET_HISTORIAL_NO_ACCESOS_USUARIO}`,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger el Cuadre"));
}

export async function getBusquedaUsuarios( valores,numPagina, tamano) {
  return await axios({
    method: "POST",
    url: `${BUSQUEDA_USUARIO_ACCEDIDO}`,
    data:valores,
    params: { pageNumber: numPagina, size: tamano }
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger usuarios conectados"));
}